/**
 * The `fields=` projection for the root event list.
 *
 * The dashboard page prefetches page 1 and hands it to `EventsProvider` as
 * `initialEvents`; the provider then fetches the same page again on mount.
 * That second request is only skippable if it is byte-for-byte the request
 * already on screen — and it was not: the two call sites had each grown their
 * own field string (different order, and only the provider asked for
 * name/locationName/start/end). One source, both callers.
 *
 * The guest-funnel fields are computed live server-side and drive the grid
 * card's per-state segments; dropping them collapses the card bar to a single
 * grey total.
 */
const BASE_FIELDS = [
  "name",
  "locationName",
  "start",
  "end",
  // plugins + capabilities drive the role-aware row deep-link (EventRows), so a
  // restricted CUSTOM role lands on a section it may actually open.
  "plugins",
  "role",
  "capabilities",
  "guestsTotal",
  "guestsUncontacted",
  "guestsContacted",
  "guestsAccepted",
  "guestsDeclined",
  "guestsWaitlist",
  "guestsCheckedIn",
  // The one-time date-jump budget. The inline date editor can spend it, so the
  // list needs it to warn before the save instead of after the 409.
  "bigDateJumpCount",
  // PB-EDP-1: the archived row menu and the bulk delete warn when an event
  // holds a paid event plan (it ends with the delete, no refund).
  "planType",
] as const;

/** `fields=` value for a root event-list request under the given view. */
export function eventListProjection(viewFields: readonly string[]): string {
  // Deduped: a view that already selects `name` must not make the two callers
  // produce different strings for the same request.
  const seen = new Set<string>(BASE_FIELDS);
  for (const f of viewFields) {
    if (f) seen.add(f);
  }
  return [...seen].join(",");
}
